import { render } from "./AdminLayoutComponent.vue?vue&type=template&id=78a44c9a"
import script from "./AdminLayoutComponent.vue?vue&type=script&lang=js"
export * from "./AdminLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__